import { useDispatch } from "react-redux";
import { AutoProgressButton } from "../forms/fields/AutoProgressButton";
import { CreditCard } from "@mui/icons-material";
import { useStatusButtonStyles } from "./ConfirmButton";
import { useSuccess, useError } from "../../../hooks/useNotifications";
import { useTranslate } from "../../providers/LocalizationProvider";
import { confirmEntries } from "../../../actions/entry";
import { useParams } from "react-router-dom";

const useConfirmEntries = (
    entries,
    updateFailedPayments,
    clearFailedPayments,
) => {
    const { event_division_id } = useParams();
    const dispatch = useDispatch();
    const { notifySuccess } = useSuccess();
    const { notifyError } = useError();

    return (e) => {
        e.stopPropagation();
        clearFailedPayments();

        const allUnconfirmed = entries.filter(
                (entry) =>
                    (entry.status === "waitlisted" &&
                        (!entry.payment ||
                            entry.payment.status !== "pending")) ||
                    entry.status === "registered",
            ),
            anyConfirmed = entries.some(
                (entry) => entry.status === "confirmed",
            ),
            anyPending = entries.some(
                (entry) =>
                    entry.status === "waitlisted" &&
                    entry.payment?.status === "pending",
            );

        if (allUnconfirmed.length > 0) {
            return dispatch(confirmEntries(event_division_id, allUnconfirmed))
                .then(({ data }) => {
                    const failedPayments = data.rejected.map(
                        (rejected) => rejected.entries,
                    );
                    failedPayments.length > 0
                        ? updateFailedPayments(failedPayments)
                        : notifySuccess("Entries successfully confirmed!");
                })
                .catch((e) => {
                    notifyError("Oops, something went wrong!");
                });
        } else if (anyConfirmed && !anyPending) {
            notifySuccess("Entries are already confirmed.");
        } else if (!anyConfirmed && anyPending) {
            notifySuccess("Entries are already pending payment.");
        } else if (anyConfirmed && anyPending) {
            notifySuccess("Entries are already confirmed or pending payment.");
        }
    };
};

export const BulkConfirmButton = ({
    entries,
    updateFailedPayments,
    clearFailedPayments,
}) => {
    const confirm = useConfirmEntries(
        entries,
        updateFailedPayments,
        clearFailedPayments,
    );
    const classes = useStatusButtonStyles();
    const buttonLabel = useTranslate("confirm_selected", {
        size: entries.length,
    });
    const showCreditCard = entries.some(
        (entry) => entry.payment && entry.payment.status === "setup",
    );

    return (
        <AutoProgressButton
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={confirm}
            startIcon={showCreditCard && <CreditCard />}
        >
            {buttonLabel}
        </AutoProgressButton>
    );
};
